import React, { Component } from 'react';
import {withRouter} from "react-router";
import {connect} from "react-redux";
import * as userReducers from "../../reducers/user";
import * as userActions from "../../actions/user";

import ListItem from '../common/listItem';
import UserNewItem from './UserNewItem';

import Loader from 'react-loader-spinner';

class UserContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            userDet : JSON.parse(window.localStorage.userDet),

        };
        this.forceUpdateHandler = this.forceUpdateHandler.bind(this);

    }


    componentDidMount() {
        let data = { userid : this.state.userDet.user_id };
        this.props.allUserData(data);

    }
    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.userData.userCreated !== prevProps.userData.userCreated) {
            let data = { userid : this.state.userDet.user_id };
            this.props.allUserData(data);
        }
        if (this.props.userData.searchText !== prevProps.userData.searchText ) {

        }
    }

    forceUpdateHandler(){
        let data = { userid : this.state.userDet.user_id };
        this.props.allUserData(data);
    }

    render() {

            let userList = (this.props.userData.searchText || this.props.userData.sort) ? this.props.userData.filteredData :  this.props.userData.userList;
           // let userList = this.props.userData ? this.props.userData.userList : undefined;
        //let vignet = this.state.vignet;

        console.log(userList);
       //console.log(this.state.showDetailPop);



        return (
            <div className="list-wrap">
                <div className="list-container">
                    {!userList &&
                    <div className="loaderWrapper">
                        <Loader type="ThreeDots" color="#23ada6"  height="50" width="50"/>
                    </div>
                    }
                    <UserNewItem />
                    { userList &&

                    userList.map((entry, index) => <ListItem detail={entry} id={index}  itemType = 'user' />)

                    }




                </div>



            </div>

        )
    }

}
function mapStateToProps(state) {
    return {
        userData  :userReducers.getUserData(state)
    };

}
export default  withRouter(connect(mapStateToProps, {
    allUserData : userActions.fetchUserData,
   allFilteredData : userActions.searchUser
})(UserContainer));


// WEBPACK FOOTER //
// ./src/components/user/UserContainer.js